import { Button } from 'blaze-ui/Button'
import { ArrowRight } from 'blaze-ui/icons'
import { Text } from 'blaze-ui/Text/Text'
import Styles from './BackgroundsDrawer.module.scss'
import { observer } from 'mobx-react-lite'
import { useRootStore } from 'stores/RootStore'
import { FillStyle } from 'components/VisualStudioPlayground/VisualEditor/StyleProps'
import { getBackgroundImage, getColors, getCurrentFrame } from 'components/VisualStudioPlayground/VisualEditor/helpers'
import { Color } from 'components/VisualStudioPlayground/VisualEditor/Types'
import { useEditor } from 'components/VisualStudioPlayground/VisualEditorContext'
import { ColorsGrid } from 'components/Design/ColorsPanel/ColorsGrid'
import { BACKGROUND_COLORS, BACKGROUND_GRADIENTS } from 'components/Design/ColorsPanel/constants'

export const ColorsRow = observer(() => {
  const { designStore, drawersStore } = useRootStore()
  const editor = useEditor()
  const styleType = FillStyle
  const currentFrame = getCurrentFrame(editor)

  const colorSize = (window.innerWidth - 30 - 48) / 7

  if (!currentFrame) return null

  const onColorSelect = (color: Color) => {
    editor.batch(() => {
      const existingBackgroundImage = getBackgroundImage(editor, currentFrame.id)
      if (existingBackgroundImage) {
        editor.deleteShape(existingBackgroundImage.id)
      }
      editor.updateShape({
        ...currentFrame,
        props: {
          fill: color,
        },
      })
      drawersStore.resetSnap()
    })
  }

  const handleSeeAll = () => {
    designStore?.openPanel({
      type: 'colors',
      styleProp: styleType,
      defaultColor: currentFrame.props.fill,
      colors: Array.from(getColors(editor).values()),
      allowGradient: true,
      allowTransparency: true,
      onChange: onColorSelect,
    })
  }

  return (
    <div>
      <div className={Styles.sectionHeader}>
        <Text variant="smallList" color="var(--dark-80)">
          Colors & Gradients
        </Text>
        <Button variant="ghost" size="xs" endIcon={ArrowRight} onPress={handleSeeAll}>
          See All
        </Button>
      </div>

      <div className={Styles.colorGrids}>
        <ColorsGrid
          colors={BACKGROUND_COLORS.slice(0, 7)}
          selectedColor={currentFrame.props.fill}
          onSelect={onColorSelect}
          size={colorSize}
        />
        <ColorsGrid
          colors={BACKGROUND_GRADIENTS.slice(0, 7)}
          selectedColor={currentFrame.props.fill}
          onSelect={onColorSelect}
          size={colorSize}
          newButtonColor={{
            type: 'linearGradient',
            angle: 0,
            stops: [
              { color: '#FFFFFF', position: 0, opacity: 1 },
              { color: '#FFFFFF', position: 1, opacity: 1 },
            ],
          }}
        />
      </div>
    </div>
  )
})
